import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AddPickupLocation from "../../images/pickUpLocation.png"

const PickupLocations = () => {
  const PickupLocationsDoc = {
    title: "Pickup Location Management",
    description: "Learn how to manage pickup locations efficiently.",
    sections: [
      {
        title: "Overview",
        content:
          "The company has designated pickup points that are established for customer convenience. These locations are rarely updated due to the logistical complexities involved in setting them up.",
      },
      {
        title: "Pickup Location",
        content: "Add pickup locations and any relevant comments.",
        image: AddPickupLocation,
        imageAlt: "Add Pickup Location",
        imageCaption: "Figure 1: Comprehensive view of the add pickup location modal",
        subsections: [
          {
            title: "Add Pickup Locations",
            steps: [
              "Remarks: Include any additional information you want the customer to know about their delivery location.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...PickupLocationsDoc} />;
};

export default PickupLocations;
